import { createFileRoute } from '@tanstack/react-router';
import { RecipeDetail } from '../features/recipes/RecipeDetail.tsx';

export const Route = createFileRoute('/recipes/$id')({ component: RecipeDetailScreen });

function RecipeDetailScreen() {
  const { id } = Route.useParams();
  return <RecipeDetail id={id} />;
}
